import axiosInstance from "./axiosInstance";

export const fetchDashboardData = async (studentIdForGuardian : string) => {

    const response = await axiosInstance.get('/dashboard', {
        params: studentIdForGuardian ? { studentIdForGuardian } : undefined,
      });
    return response.data.data;
};